
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";
import { OpenseaToken, TokenMeta, FirestoreDocument } from "../../types/types";
export default defineComponent({
  props: {
    token: Object as () => OpenseaToken,
    selected: Boolean,
    in_playlist: Boolean
  },
  setup(props) {
    const store = useStore();
    const token_meta = computed(
      (): FirestoreDocument<TokenMeta> => {
        return store.getters.demo_token_meta(
          props.token?.asset_contract.address,
          props.token?.token_id
        );
      }
    );
    return { token_meta };
  }
});
